var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0743 10.9639C20.4649 7.71289 20.1597 6.08685 19.0024 5.12643C17.8461 4.16602 16.192 4.16602 12.8847 4.16602H12.1336C8.82529 4.16602 7.17217 4.16602 6.01488 5.12643C4.85758 6.08685 4.55238 7.71289 3.94196 10.9639C3.08571 15.5358 2.65654 17.8212 3.90654 19.3275C5.1555 20.8327 7.4805 20.8327 12.1326 20.8327H12.8836C17.5347 20.8327 19.8607 20.8327 21.1107 19.3275C21.8357 18.4525 21.9961 17.3171 21.8347 15.6243",
    stroke: "rgba(0,0,0,1)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55078 8.33203C9.76599 8.94196 10.1651 9.47012 10.6931 9.84371C11.2211 10.2173 11.8519 10.4179 12.4987 10.4179C13.1455 10.4179 13.7763 10.2173 14.3043 9.84371C14.8323 9.47012 15.2314 8.94196 15.4466 8.33203",
    stroke: "rgba(0,0,0,1)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrders);
export default __webpack_public_path__ + "static/media/Icon-orders.b6cfd3ad159d3ce9176bfea9eb8780b6.svg";
export { ForwardRef as ReactComponent };